import { apiProxy, Payload } from './proxy.services';

const DATASERVICE_API = `${process.env.VUE_APP_DATASERVICE_API}`;

const ITEMS = '/items';

export default {
   async getSellerDetails(sellerId) {
        const options = new Payload(`${DATASERVICE_API}${ITEMS}?networkid=CL-SELLER-${sellerId}`, 'GET');

        try {
            const response = await apiProxy(options);
            const data = await response.data;
            return data;

        } catch (error) {
            if (error.response)
                throw new Error(error.response.data.customMessage || error.response.data.message);

            throw new Error(error);
        }
    },
    async getAdvertDetails(networkId) {
        const options = new Payload(`${DATASERVICE_API}${ITEMS}?networkid=${networkId}`, 'GET');

        try {
            const response = await apiProxy(options);
            const data = await response.data;
            return data;

        } catch (error) {
            if (error.response)
                throw new Error(error.response.data.customMessage || error.response.data.message);

            throw new Error(error);
        }
    },
};
